import { axiosLocal5000Local } from "../axios";

export async function getSymbolsDetails(selectedSymbol:any,startDate:any, endDate:any, calculation_type:any,type:any ){
    return await axiosLocal5000Local.post(`equity-spot-multiday/find-by-symbols-and-dates`,{
        s_symbol: selectedSymbol,
        startDate : startDate,
        endDate : endDate,
        asset_type: calculation_type,
        type:type
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the symbol details for historical performance : ", error)
        return {"error": true}
       
    })
}

export async function getAllDetails(codes:string[]){
    return await axiosLocal5000Local.post(`equity-spot-multiday/`,{symbols:codes}).then((res:any)=>{
        return res;
    }).catch((error:any)=>{
        console.log("Exception occured while fetching all the details for performance page : ", error)
        return {"error": true}
    })
}

// export async function getRollingChartsDetailsSymbolWise(drpValue:any, startDate:any, endDate:any) {
//     return await axiosLocal5000Local.post(`equity-spot-multiday/get-symbol-chart`, {
//         s_symbol: drpValue,
//         startDate: startDate,
//          endDate: endDate 
//     }).then((res:any)=>{
//         return res
//     }).catch((error:any)=>{
//         console.log("Exception occured while fetching all the charts data for performance page : ", error)
//         return {"error": true}
//     })
// }

export async function getRollingChartsDetailsSymbolWise(drpValue:any, startDate:any, endDate:any,type:any) {
    return await axiosLocal5000Local.post(`equity-spot-multiday/get-symbol-chart`, {
        s_symbol: drpValue,
        startDate: startDate,
         endDate: endDate,
         type:type
    }).then((res:any)=>{
        return res
    }).catch((error:any)=>{
        console.log("Exception occured while fetching all the charts data for performance page : ", error)
        return {"error": true}
    })
}
// export async function getPropertyCharts(selectedColumn:any, startDate:any, endDate:any, drpValue:any, type:any) {
//     return await axiosLocal5000Local.post(`equity-spot-multiday/fetch-column-data`, {
//         column_name: selectedColumn,
//         startDate: startDate,
//         endDate: endDate, 
//         s_symbol: drpValue 
//     }).then((res:any)=>{
//         return res?.data ;
//     }).catch((error:any)=>{
//         console.log("Exception occured while fetching the details or property charts for performance page : ", error)
//         return {"error": true}
//     })
// }

export async function getPropertyCharts(selectedColumn:any, startDate:any, endDate:any, drpValue:any,type:any) {
    return await axiosLocal5000Local.post(`equity-spot-multiday/fetch-column-data`, {
        column_name: selectedColumn,
        startDate: startDate,
        endDate: endDate,
        s_symbol: drpValue,
        type:type
    }).then((res:any)=>{
        return res?.data ;
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the details or property charts for performance page : ", error)
        return {"error": true}
    })
}
    export async function getTableExport(selectedSymbol:any,startDate:any, endDate:any, calculation_type:any ,type:any){
        return await axiosLocal5000Local.post(`equity-spot-multiday/get-table-for-export`,{
            s_symbol: selectedSymbol,
            startDate : startDate,
            endDate : endDate,
            asset_type: calculation_type,
            type:type
        }).then((res:any)=>{
            return res?.data
        }).catch((error:any)=>{
            console.log("Exception occured while fetching ExportPdf data for historical performance : ", error)
            return {"error": true}
           
        })
}



export async function getEquityReturnDetails( year:any, type: any){
    return await axiosLocal5000Local.post(`equity-spot-multiday/get-equity-return`,{
        year        : year,
        type        : type
        }).then((res:any)=> {
            return res?.data
        }).catch((error:any)=> {
            console.log("Exception occured while fetching getEquityReturnDetails data for historical performance : ", error)
            return {"error": true}
        })
}
export async function getSymbolOptions(type: any){
    return await axiosLocal5000Local.post(`equity-spot-multiday/get-symbols`,{
        type        : type
        }).then((res:any)=> {
            return res?.data
        }).catch((error:any)=> {
            console.log("Exception occured while fetching getSymbolOptions data for historical performance : ", error)
            return {"error": true}
        })
}
export async function getRollingChartValue(symbol: any, rolling:any, type : any, startDate:any, endDate:any){
    return await axiosLocal5000Local.post(`equity-spot-multiday/get-chart-value`,{
        symbol  : symbol,
        rolling : rolling,
        type    : type,
        startDate: startDate,
        endDate : endDate
        }).then((res:any)=> {
            return res?.data
        }).catch((error:any)=> {
            console.log("Exception occured while fetching getRollingChartValue data for historical performance : ", error)
            return {"error": true}
        })
}
export async function getMonthlyRollingChartValue(symbol: any, year:any, type : any, startDate: any, endDate: any){
    return await axiosLocal5000Local.post(`equity-spot-multiday/get-monthly-chart-value`,{
        symbol  : symbol,
        year    : year,
        type    : type,
        startDate: startDate,
        endDate : endDate
        }).then((res:any)=> {
            return res?.data
        }).catch((error:any)=> {
            console.log("Exception occured while fetching getMonthlyRollingChartValue data for historical performance : ", error)
            return {"error": true}
        })
}

export async function getRollingPdf(symbol: any, rolling:any, type : any, startDate:any, endDate:any){
    return await axiosLocal5000Local.post(`equity-spot-multiday/get-chart-pdf-export`,{
        symbol  : symbol,
        rolling : rolling,
        type    : type,
        startDate: startDate,
        endDate : endDate
        }).then((res:any)=> {
            return res?.data
        }).catch((error:any)=> {
            console.log("Exception occured while fetching ExportPdf data for historical performance : ", error)
            return {"error": true}
})
}